var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LayoutBase',{attrs:{"paddingTop":false,"paddingLeft":false,"paddingRight":false,"paddingBottom":false}},[_c('div',{class:_vm.contentClass,style:(_vm.contentStyle)},[_c('div',{staticClass:"flex flex-grow flex-col h-full"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }